import { apiFetch } from "./apiClient";

export async function fetchProfiles() {
  const result = await apiFetch("/api/profiles");

  return result.profiles;
}

export async function fetchProfileById(profileId) {
  const result = await apiFetch(`/api/profiles/${profileId}`);

  return result.profile;
}

export async function loginProfile(contact, password) {
  const result = await apiFetch(`/api/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ contact, password }),
  });

  return result.profile;
}

export async function updateProfile(profileId, payload) {
  const result = await apiFetch(`/api/profiles/${profileId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return result.profile;
}
